(function () {
    'use strict';

    angular.module("imApp").factory("acSuppTransService", ['$ihttp', function ($ihttp) {
        let service = {
            getAcSuppTrans: function (parms) {
                return $ihttp.post({
                    method: 2828,
                    parameters: parms || {}
                });
            },
            removeMatchingSelected: function (mergeObj) {
                return $ihttp.post({
                    method: 2830,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
